var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    { attrs: { toggleable: "lg", type: "dark", variant: "info" } },
    [
      _vm.empresa.token !== ""
        ? _c("b-navbar-brand", { attrs: { to: "/" } }, [
            _vm.ruta_actual !== "/"
              ? _c(
                  "button",
                  {
                    staticClass:
                      "d-block d-sm-none btn btn-outline-light btn-sm",
                  },
                  [_vm._v("\n      Inicio\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "d-none d-sm-block img-fluid",
              staticStyle: { "max-height": "38px" },
              attrs: {
                alt: "Panel de control Empresas de Mudanzas",
                src: _vm.base_url + "img/pro/favicon_mm_pro.webp",
              },
            }),
          ])
        : _c("b-navbar-brand", [
            _vm.ruta_actual !== "/login"
              ? _c(
                  "button",
                  {
                    staticClass:
                      "d-block d-sm-none btn btn-outline-light btn-sm",
                  },
                  [_vm._v("\n      Inicio\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "d-none d-sm-block img-fluid",
              staticStyle: { "max-height": "43px" },
              attrs: {
                alt: "Panel de control Empresas de Mudanzas",
                src: _vm.base_url + "img/pro/logo_pro_white.png",
              },
            }),
          ]),
      _vm._v(" "),
      _vm.empresa.token !== "" && _vm.ruta_actual !== "/"
        ? _c(
            "b-navbar-nav",
            { staticClass: "d-none d-sm-block" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-outline-light mr-5",
                  attrs: { to: "/" },
                },
                [_vm._v("\n      Inicio\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.empresa.token !== ""
        ? _c("b-navbar-toggle", {
            attrs: { target: "nav-collapse-dashboard-mm-pro" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.empresa.token !== ""
        ? _c(
            "b-collapse",
            { attrs: { id: "nav-collapse-dashboard-mm-pro", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                [
                  _c(
                    "b-input-group",
                    { staticClass: "mt-3 mt-lg-0" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          name: "buscar",
                          placeholder: "folio, cliente...",
                          type: "search",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.onSubmit.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.a_buscar,
                          callback: function ($$v) {
                            _vm.a_buscar =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "a_buscar",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.a_buscar == "" ? true : false,
                                variant: "outline-light",
                              },
                              on: { click: _vm.onSubmit },
                            },
                            [_c("i", { staticClass: "fas fa-search" })]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto d-flex align-items-lg-center" },
                [
                  typeof _vm.empresa.membresia_paga == "undefined" ||
                  _vm.empresa.membresia_paga <= 0
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            href:
                              _vm.base_url + "membresia/" + _vm.empresa.clave,
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-warning btn-sm text-white font-weight-bold",
                            },
                            [_vm._v("\n          Comprar membresía\n        ")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "mr-4",
                      attrs: {
                        active: "",
                        title:
                          "Centro de ayuda. Tutoriales, consejos y tips para ganar más",
                        href: _vm.base_url + "centro-ayuda-empresas-mudanzas",
                      },
                    },
                    [_c("i", { staticClass: "far fa-question-circle" })]
                  ),
                  _vm._v(" "),
                  _c("notificaciones-proveedor", { staticClass: "mr-4" }),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "mr-4",
                      attrs: {
                        active: "",
                        title:
                          "Agendar llamadas con clientes para aumentar mis ventas",
                        to: "/calendario_llamada",
                      },
                    },
                    [_c("i", { staticClass: "far fa-calendar-alt" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "far fa-user" }),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.empresa.usuario) +
                                    "\n        "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        929096071
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { to: "/perfil" } }, [
                        _vm._v("Perfil"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: `/cambiar_contrasena?token=${_vm.empresa.token}&id=${_vm.empresa.id}&modulo=pro`,
                          },
                        },
                        [_vm._v("\n          Cambiar contraseña\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/configurar_alertas_trabajo" } },
                        [
                          _vm._v(
                            "\n          Configurar alertas de trabajo\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { href: _vm.base_url + "pro/contenido" } },
                        [
                          _vm._v(
                            "\n          Contenido y publicaciones\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { to: "/papelera" } }, [
                        _vm._v(
                          "\n          Ver solicitudes que has archivado\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { href: _vm.base_url + "privacidad" } },
                        [_vm._v("\n          Aviso de privacidad\n        ")]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { on: { click: _vm.cerrar_sesion } },
                        [_vm._v("Salir")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }